import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormControlName, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbAlertModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HireSearchService } from '../services/hire-search.service';
import { CandidateSelectionService } from 'src/app/projects/services/candidate-selection.service';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { CustomValidator } from 'src/app/_services/customValidator';

import { ClickOutsideDirective } from 'src/app/directives/click-outside.directive';

@Component({
  selector: 'app-add-to-pipeline-stage',
  imports: [ReactiveFormsModule, TitleCasePipe, NgbAlertModule,  ClickOutsideDirective],
  templateUrl: './add-to-pipeline-stage.component.html',
  styleUrl: './add-to-pipeline-stage.component.scss',
})
export class AddToPipelineStageComponent implements OnChanges {
  @Input() stageList:any;
  filteredStageList: any;
  stageSearch: FormControl = new FormControl();
  isDropdownOpen = false;
  selectdStage:any;
  statusname: FormControl = new FormControl(null, [Validators.required, CustomValidator.noHtmlValidator()]);
  @ViewChild('createStageModal') createStageModal: TemplateRef<any>;
  @Input() candidate: any;
  projectnumber: string;
  successMessage: string = ''; // Property to hold the success message
  errorMessage: string = ''; // Property to hold the error message
  @Input() type: string;
  talentmappingid: any;
    @Output() stageUpdated = new EventEmitter<{ candidate: any, stage: string }>();

constructor(private modalService: NgbModal, private hireSearchService: HireSearchService, private candidateSelectionService: CandidateSelectionService) {
  this.projectnumber = window.location.pathname?.split('/')[2];
  this.statusname.setValue(this.candidate?.talentpoolMappingDetails?.pipelinestage)
}

ngOnInit() {
  console.log('candidate in stage', this.candidate);
   this.statusname.setValue(this.candidate?.talentpoolMappingDetails?.pipelinestage)

 }

 /**
  * The `candidate` @Input is only re-set by the parent AFTER the very first render when
  * the candidate's stage changes somewhere else (e.g. a bulk stage update touching a card
  * that isn't the one the user actually clicked). Without this, that card's dropdown label
  * would keep showing the old stage until the page is reloaded, even though the underlying
  * data updated.
  */
 ngOnChanges(changes: SimpleChanges) {
   if (changes['candidate'] && !changes['candidate'].firstChange && this.type !== 'bulk') {
     this.statusname.setValue(this.candidate?.talentpoolMappingDetails?.pipelinestage, { emitEvent: false });
   }
 }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.stageSearch.setValue('');
      this.filteredStageList = [...this.stageList];
    }
  }

  filterStage() {
     this.filteredStageList = this.stageList.filter(c =>
      c.toLowerCase().includes(this.stageSearch.value.toLowerCase())
    );
  }

  selectStage(stage) {
    this.selectdStage = stage;
  }

  createNewStage() {
    const modalRef = this.modalService.open(this.createStageModal, { size: 'xs' as 'md', windowClass:'button-place', centered: true, backdrop: true, keyboard: false });

  }

  dismiss() {
    this.modalService.dismissAll();
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  createStage(stage?: string) {

    if (!stage && this.statusname.invalid) {
      return;
    }

    const sanitizedCustomStage = CustomValidator.stripHtmlTags(this.statusname.value);

    const payload = {
      projectnumber: this.projectnumber,
      talentpoolcandidatemappingids: [this.candidate?.talentpoolMappingDetails?.talentpoolcandidatemappingid],
      pipelinestage: stage ? stage : sanitizedCustomStage
    };

   // Candidate number(s) affected by this update - used to broadcast the change to every
   // other surface (candidate cards, the slider, other stage dropdowns) via
   // CandidateSelectionService, regardless of whether those surfaces are wired up to
   // this component's @Output().
   let affectedCandidateNumbers: string[] = [];

   if(this.type === 'bulk') {
     this.talentmappingid =  this.candidate.map((candidate: any) => {
        return candidate?.talentpoolMappingDetails?.talentpoolcandidatemappingid;
      })
      payload.talentpoolcandidatemappingids = this.talentmappingid;
      affectedCandidateNumbers = (this.candidate || [])
        .map((candidate: any) => candidate?.basicdetails?.candidatenumber || candidate?.candidatenumber || candidate?.id)
        .filter(Boolean);
    } else {
      const cn = this.candidate?.basicdetails?.candidatenumber || this.candidate?.candidatenumber || this.candidate?.id;
      if (cn) {
        affectedCandidateNumbers = [cn];
      }
    }

    this.hireSearchService.updatePipelineStage(payload).subscribe((response: any) => {
      if(response.success === true) {
        this.successMessage = 'Stage created successfully!';
       this.dismiss();
 this.statusname.setValue(payload.pipelinestage);
        this.stageUpdated.emit({ candidate: this.candidate, stage: payload.pipelinestage });
        // Single source of truth broadcast: every card, the slider (if open), and any other
        // open stage dropdown update instantly, and the new stage shows up in every stage
        // list immediately - no full reload / refetch required.
        this.candidateSelectionService.notifyStageUpdated(affectedCandidateNumbers, payload.pipelinestage);
        this.candidateSelectionService.addStageIfMissing(payload.pipelinestage);
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
        this.closeDropdown();
      } else {
        this.errorMessage = 'Failed to create stage.';
        setTimeout(() => {
          this.errorMessage = '';
          this.dismiss();
        }, 3000);
        this.closeDropdown();
      }

    })
  }
}
